module.exports = __WEBPACK_EXTERNAL_MODULE_227__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/Observable"
// module id = 227
// module chunks = 0